// Parts of the add-job form that must never count as a click on the map: the
// popup itself, and the Material-UI menu a form select opens. The menu is
// portalled into document.body, outside the popup, and opens on mouse-down, so
// the mouse-up lands on it and react-map-gl reports a map click.
const MAP_CLICK_IGNORED_SELECTOR = '.mapboxgl-popup, .MuiPopover-root, .MuiBackdrop-root'

function isClickOnMapOverlay(target) {
  return Boolean(target && target.closest && target.closest(MAP_CLICK_IGNORED_SELECTOR))
}

export { isClickOnMapOverlay }
